import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";
import { selectForumSubscriptionsListItems } from "../../../../../../redux/forum-subscriptions/selector";
import { forumSubscriptions } from "../../../../../../redux/forum-subscriptions/action";


const ForumSubscriptions = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);

    const ForumSubscriptionsItems = useSelector(selectForumSubscriptionsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
         
          { field: 'ForumId', headerName: 'Forum', searchField: 'ForumId', filter: true,
            filterType: 'text' },
            { field: 'TopicId', headerName: 'Topic'},
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat:true},
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat:true},
           
 

        ]);
      }


      const handleSearch = (data: any) => {
      
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(forumSubscriptions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/forum/forum-subscriptions/list`,entity:'forumSubscriptions',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
    
      

      const handleReloadData = () => {
        dispatch(forumSubscriptions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/forum/forum-subscriptions/list`,entity:'forumSubscriptions',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const handleEdit=(data: any)=>{
        navigate(`${data?.Id}`)
      }
        
      const fetchForumSubscriptions=()=>{
        dispatch(forumSubscriptions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/forum/forum-subscriptions/list`,entity:'forumSubscriptions',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
     
      const additionButtons: any = [
      
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        
        callback: () => handleReloadData(),
        },
      ];
	useEffect(() => {
        createColumnDefs()
        fetchForumSubscriptions()
	}, [pageData,pageSize])
  const handleDelete=(data: any)=>{
    dispatch(forumSubscriptions.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/forum/forum-subscriptions/delete`,
      entity: 'forumSubscriptions',
      jsonData: {
        Records: [
          {
         
                Id: data?.Id
            }
          
        ]
      }
  })).then(() => {
    dispatch(forumSubscriptions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/forum/forum-subscriptions/list`,entity:'forumSubscriptions',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  });
  }
	return (
    <>
    {ForumSubscriptionsItems?.isLoading ?  <PageLoader />: 
		<Table   enableFilter={true}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} columnData={columnDefs} rowData={ForumSubscriptionsItems?.result?.items} setPageData={setPageData}
    setPageSize={setPageSize}paginationData={ForumSubscriptionsItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete}headingName="Forum Subscriptions"/>
     
  }
  </> 
	);
};

export default ForumSubscriptions;